<header>
  <div class="header-innerFrame">
    <div class="logo">
      <!-- <a href="https://www.mizrahi-tefahot.co.il"> -->
      <a (click)="restart()">
        <img src="assets/app-images/logo/logo-mizrahi-mortgage-2@3x.png" alt="{{'COMMON.LOGO_ALT' | translate}}"
          class="m-logo">
      </a>
    </div>
    <ul class="text-left" *ngIf="!hideLeftButtons">
      <!-- <li (click)="restartClick()" (keyup.enter)="restartClick()" tabindex="0"><img src="assets/app-images/icons/icons-24-refresh.svg" alt="" attr.aria-label="{{'COMMON.UNDO'| translate}}"><span>{{'COMMON.UNDO'| translate}}</span></li> -->
      <li *ngIf="(asmachta$|async)!==''" [hidden]="this.isCurrentStepFirst$|async" (click)="saveProcess()"
        (keyup.enter)="saveProcess()" tabindex="0">
        <button class="app-button button-secondery btn-process">
          <img src="assets/app-images/icons/icons-24-px-save.svg" alt=""
            attr.aria-label="{{'START.SAVE-PROCESS'| translate}}">
          <span>{{'START.SAVE-PROCESS'| translate}}</span>
        </button>
      </li>
      <!-- <li (click)="openHelpDialog()" (keyup.enter)="openHelpDialog()" tabindex="0"><img src="assets/app-images/icons/icons-24-px-phone-chat.svg" alt="" attr.aria-label="{{'START.SEND-LEAD'| translate}}"><span>{{'START.SEND-LEAD'| translate}}</span></li> -->
      <li class="mr-2" *ngIf="(asmachta$|async)!==''" tabindex="0"><span>{{'COMMON.ASMACHTA'| translate}}
          {{asmachta$|async}}</span></li>
    </ul>
  </div>
</header>


// WEBPACK FOOTER //
// ./src/app/header/header.component.html